// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__565iv","content":"LoadingAlert_content__10zg3"};